import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import {
  IEditTemplate,
  IParamsGetTemplate,
  IResponseGetTemplate,
  IResponseGetTemplateDetail,
  IPayloadDeleteTemplates,
} from '~/utils/interface/template';

const urlTemplate = `api/admin/templates`;

const templateApi = {
  getTemplates(params: IParamsGetTemplate) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTemplate>>(urlTemplate, { params });
  },
  createTemplate(data: IEditTemplate) {
    return axiosClient.post<IApiBaseResponse<IResponseGetTemplateDetail>>(urlTemplate, data);
  },
  getTemplate(id: string, type: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTemplateDetail>>(`${urlTemplate}/${id}/${type}`);
  },
  updateTemplate(id: string | undefined, type: string | undefined, data: IEditTemplate) {
    return axiosClient.put<IApiBaseResponse<null>>(`${urlTemplate}/${id}/${type}`, data);
  },
  deleteTemplate(data: IPayloadDeleteTemplates) {
    const url = `${urlTemplate}`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
};

export default templateApi;
